module.exports = __webpack_public_path__ + "media/components/country-flag/static/ws-cbd113c7fb692f410a0dc0b5db44a88f.svg";